import * as React from "react";
import CloseIcon from "@mui/icons-material/Close";
import VerifiedIcon from "@mui/icons-material/Verified";
import EastIcon from "@mui/icons-material/East";
import { countries } from "../utils/Country.js";
import axios from "axios";
import {
  Modal,
  Typography,
  Box,
  TextField,
  InputAdornment,
  Select,
  FormControl,
  FormHelperText,
  Button,
  IconButton,
  Snackbar,
  Alert,
} from "@mui/material";
import Calendary from "./Products/Calendary.js";
import { SERVER_URL } from "../config/config.js";

export default function DemoModal({ open, onClose }) {
  const initialState = {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    code: "+91",
    country: "",
    company: "",
  };

  const [formData, setFormData] = React.useState(initialState);
  const [openCalender, setCalenderOpen] = React.useState(false);
  const [openForm, setOpenForm] = React.useState(false);
  const [date, setDate] = React.useState(new Date());
  const [time, setTime] = React.useState("");
  const [snackOpen, setsnackOpen] = React.useState({
    open: false,
    message: "",
    severity: "",
  });
  const [snackOpenPopup, setsnackOpenPopup] = React.useState({
    open: false,
    message: "",
    severity: "",
  });
  const [errors, setErrors] = React.useState({});

  const handleClose = () => {
    onClose();
    setFormData(initialState);
    setErrors({});
    setOpenForm(false);
    setCalenderOpen(false);
    setsnackOpen({
      open: false,
      message: "",
      severity: "",
    });
  };

  const handleOpen = () => {
    setOpenForm(true);
    setsnackOpen({
      open: false,
      message: "",
      severity: "",
    });
    setFormData(initialState);
    setErrors({});
  };

  const validateForm = () => {
    const errors = {};

    if (!formData.firstName.trim())
      errors.firstName = "First name is required.";
    if (!formData.lastName.trim()) errors.lastName = "Last name is required.";
    if (!formData.email.trim()) {
      errors.email = "Email is required.";
    } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
      errors.email = "Email is invalid.";
    }

    if (!formData.phone.trim()) {
      errors.phone = "Phone is required.";
    } else if (!formData.code.trim()) {
      errors.phone = "Country code is required.";
    }
    if (!formData.country.trim()) errors.country = "Country is required.";
    if (!formData.company.trim()) errors.company = "Company is required.";
    setErrors(errors);
    return Object.keys(errors).length === 0 ? false : errors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "phone") {
      if (value !== "" && (!/^\d+$/.test(value) || value.length > 10)) return;
    }
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const checkEmailDomain = (email) => {
    if (typeof email !== "string") return false;

    const domains = ["gmail.com", "yahoo.com", "hotmail.com", "rediff.com"];
    const emailDomain = email.toLowerCase().split("@")[1];

    return domains.includes(emailDomain);
  };

  const handleSubmit = async () => {
    if (validateForm()) return;

    if (checkEmailDomain(formData.email)) {
      setsnackOpenPopup({
        open: true,
        message:
          "Please use your official company email address. Personal domains like Gmail, Yahoo, Hotmail, or Rediff are not allowed.",
        severity: "error",
      });
      return;
    }

    setCalenderOpen(true);
  };

  const calendarySubmit = async () => {
    const dateForSlot = date.toLocaleDateString("en-CA");
    await axios
      .post(`${SERVER_URL}/nirantara/lead/submit`, {
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        phone: `${formData.code}${formData.phone}`,
        country: formData.country,
        company: formData.company,
        code: formData.code,
        date: dateForSlot,
        time,
      })
      .then((res) => {
        setCalenderOpen(false);
        setsnackOpen({
          open: true,
          message: "Demo request submitted successfully!",
          severity: "success",
        });
        setsnackOpenPopup({
          open: true,
          message: "Demo request submitted successfully!",
          severity: "success",
        });
      })
      .catch((err) => {
        console.log(err?.response?.data?.message, "error");
        setsnackOpenPopup({
          open: true,
          message: err?.response?.data?.message ?? "An error occurred",
          severity: "error",
        });
        if (
          err?.response?.data?.message ===
          "You already had a meeting scheduled."
        ) {
          setCalenderOpen(false);
        }
      });
  };

  return (
    <>
      <Snackbar
        open={snackOpenPopup.open}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={() => setsnackOpenPopup({ ...snackOpenPopup, open: false })}
      >
        <Alert
          severity={snackOpenPopup.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackOpenPopup.message}
        </Alert>
      </Snackbar>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="demo-modal-title"
        aria-describedby="demo-modal-description"
      >
        <Box
          sx={{
            position: "fixed",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              position: "relative",
              width: {
                xs: "90vw",
                sm: openForm ? 700 : 500,
              },
              "@media (min-width: 1024px)": {
                width: openForm ? "60vw" : 600,
              },
              maxWidth: "90vw",
              boxSizing: "border-box",
              bgcolor: "background.paper",
              borderRadius: 2,
              boxShadow: 24,
              p: 4,
              border: "none",
            }}
          >
            {/* Close Button */}
            <IconButton
              onClick={handleClose}
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                color: "gray",
                bgcolor: "#dde0e7",
                "&:hover": {
                  bgcolor: "#e5e7eb",
                },
              }}
            >
              <CloseIcon />
            </IconButton>

            {/* Title */}
            {snackOpen.open === false && (openForm || openCalender) && (
              <Typography variant="h5" fontWeight={600} color="#1f2937" mb={3}>
                {openCalender ? "Schedule a Demo" : "Start Your Demo Tour"}
              </Typography>
            )}

            {/* Initial Screen */}
            {openForm === false ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                <h2 className="text-xl font-semibold text-green-700 mb-2">
                  Take the First Step Toward a Sustainable Future
                </h2>
                <p className="text-gray-600 mb-6">Request a Demo Today</p>

                <button
                  className="bg-green-600 text-white px-6 py-2 rounded mt-3"
                  onClick={handleOpen}
                >
                  Book a live demo <EastIcon />
                </button>
              </div>
            ) : null}

            {/* Form */}
            {openForm ? (
              <Box className="flex flex-wrap gap-4">
                {openCalender === false && snackOpen.open === false && (
                  <>
                    {/* First Name */}
                    <Box className="flex flex-col w-full sm:w-[48%]">
                      <Typography
                        sx={{ fontWeight: 600, fontSize: "15px", mb: 1 }}
                      >
                        First Name
                      </Typography>
                      <TextField
                        placeholder="First Name"
                        name="firstName"
                        size="small"
                        value={formData?.firstName || ""}
                        fullWidth
                        error={!!errors.firstName}
                        helperText={errors.firstName}
                        required
                        onChange={handleChange}
                      />
                    </Box>

                    {/* Last Name */}
                    <Box className="flex flex-col w-full sm:w-[48%]">
                      <Typography
                        sx={{ fontWeight: 600, fontSize: "15px", mb: 1 }}
                      >
                        Last Name
                      </Typography>
                      <TextField
                        placeholder="Last Name"
                        name="lastName"
                        size="small"
                        fullWidth
                        required
                        value={formData?.lastName || ""}
                        error={!!errors.lastName}
                        helperText={errors.lastName}
                        onChange={handleChange}
                      />
                    </Box>

                    {/* Business Email */}
                    <Box className="flex flex-col w-full sm:w-[48%]">
                      <Typography
                        sx={{ fontWeight: 600, fontSize: "15px", mb: 1 }}
                      >
                        Business Email
                      </Typography>
                      <TextField
                        placeholder="Business Email"
                        name="email"
                        size="small"
                        fullWidth
                        required
                        error={!!errors.email}
                        helperText={errors.email}
                        onChange={handleChange}
                        value={formData?.email || ""}
                      />
                    </Box>

                    {/* Phone with country code */}
                    <Box className="flex flex-col w-full sm:w-[48%]">
                      <Typography
                        sx={{ fontWeight: 600, fontSize: "15px", mb: 1 }}
                      >
                        Phone
                      </Typography>
                      <TextField
                        placeholder="Phone Number"
                        name="phone"
                        size="small"
                        fullWidth
                        required
                        error={!!errors.phone}
                        helperText={errors.phone}
                        value={formData?.phone || ""}
                        onChange={handleChange}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Box className="flex items-center gap-2">
                                <FormControl
                                  size="small"
                                  sx={{
                                    minWidth: 90,
                                    maxWidth: 110,
                                    "& .MuiOutlinedInput-notchedOutline": {
                                      border: "none",
                                    },
                                    "& .MuiOutlinedInput-root": {
                                      "&:hover .MuiOutlinedInput-notchedOutline":
                                        {
                                          border: "none",
                                        },
                                      "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                        {
                                          border: "none",
                                        },
                                    },
                                  }}
                                >
                                  <Select
                                    native
                                    name="code"
                                    value={formData.code || "+91"}
                                    onChange={(e) => {
                                      const selectedCode = e.target.value;
                                      // Find the country object to get the country name
                                      const countryObj = countries.find(
                                        (c) => c.dial_code === selectedCode,
                                      );
                                      setFormData((prev) => ({
                                        ...prev,
                                        code: selectedCode,
                                        country: countryObj
                                          ? countryObj.name
                                          : prev.country,
                                      }));
                                      setErrors((prev) => ({
                                        ...prev,
                                        phone: "",
                                      }));
                                    }}
                                    sx={{
                                      "& .MuiSelect-select": {
                                        padding: "6px 30px 6px 10px !important",
                                        fontSize: "14px",
                                        minHeight: "auto !important",
                                        lineHeight: "1.4375em",
                                        display: "flex",
                                        alignItems: "center",
                                        whiteSpace: "nowrap",
                                        overflow: "visible",
                                      },
                                      "& .MuiSelect-icon": {
                                        right: 6,
                                        width: "18px",
                                        height: "18px",
                                      },
                                      "& .MuiOutlinedInput-notchedOutline": {
                                        border: "none",
                                      },
                                    }}
                                  >
                                    {countries.map((c) => (
                                      <option key={c.code} value={c.dial_code}>
                                        {c.dial_code}
                                      </option>
                                    ))}
                                  </Select>
                                </FormControl>
                                <div className="text-gray-300">|</div>
                              </Box>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Box>

                    {/* Country */}
                    <Box className="flex flex-col w-full sm:w-[48%]">
                      <Typography
                        sx={{ fontWeight: 600, fontSize: "15px", mb: 1 }}
                      >
                        Country
                      </Typography>
                      <FormControl
                        fullWidth
                        size="small"
                        error={!!errors.country}
                        required
                      >
                        <Select
                          native
                          id="demo-native-country"
                          name="country"
                          value={formData.country}
                          onChange={(e) => {
                            const selectedCountry = e.target.value;
                            // Find the country object to get the dial code
                            const countryObj = countries.find(
                              (c) => c.name === selectedCountry,
                            );
                            setFormData((prev) => ({
                              ...prev,
                              country: selectedCountry,
                              code: countryObj
                                ? countryObj.dial_code
                                : prev.code,
                            }));
                            setErrors((prev) => ({
                              ...prev,
                              country: "",
                            }));
                          }}
                          inputProps={{
                            "aria-label": "Select Country",
                          }}
                          sx={{
                            "& .MuiSelect-select": {
                              paddingTop: "12px",
                              paddingBottom: "12px",
                            },
                          }}
                        >
                          <option value="">Select Country</option>
                          {countries.map((c) => (
                            <option key={c.name} value={c.name}>
                              {c.name}
                            </option>
                          ))}
                        </Select>
                        {errors.country && (
                          <FormHelperText error>
                            {errors.country}
                          </FormHelperText>
                        )}
                      </FormControl>
                    </Box>

                    {/* Company */}
                    <Box className="flex flex-col w-full sm:w-[48%]">
                      <Typography
                        sx={{ fontWeight: 600, fontSize: "15px", mb: 1 }}
                      >
                        Company
                      </Typography>
                      <TextField
                        placeholder="Company"
                        name="company"
                        size="small"
                        value={formData?.company || ""}
                        fullWidth
                        required
                        error={!!errors.company}
                        helperText={errors.company}
                        onChange={handleChange}
                      />
                    </Box>
                  </>
                )}

                {/* Calendar */}
                {openCalender && snackOpen.open === false && (
                  <Box sx={{ width: "100%", minWidth: 0 }}>
                    <Calendary
                      time={time}
                      setTime={setTime}
                      date={date}
                      setDate={setDate}
                    />
                  </Box>
                )}

                {/* Success Message */}
                {snackOpen.open ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      textAlign: "center",
                      height: "33vh",
                      flexDirection: "column",
                      width: "100%",
                    }}
                  >
                    <VerifiedIcon
                      style={{
                        color: "green",
                        fontSize: "60px",
                        marginTop: "-2rem",
                        marginBottom: "1rem",
                      }}
                    />
                    <h2
                      style={{
                        marginTop: 0,
                        marginBottom: "10px",
                        fontSize: "1.25rem",
                        fontWeight: 600,
                      }}
                    >
                      Your demo request has been submitted successfully!
                    </h2>
                    <p
                      style={{
                        fontSize: "1rem",
                        marginTop: "0.5rem",
                        lineHeight: 1.6,
                      }}
                    >
                      A confirmation receipt has been sent to your email. <br />
                      Our support team will contact you shortly with further
                      details.
                    </p>
                  </div>
                ) : null}
              </Box>
            ) : null}

            {/* Submit Button */}
            {snackOpen.open === false && openForm && (
              <Box mt={8}>
                <Button
                  variant="contained"
                  onClick={openCalender ? calendarySubmit : handleSubmit}
                  sx={{
                    backgroundColor: "#488257",
                    textTransform: "none",
                    fontWeight: 600,
                    py: 0.8,
                    "&:hover": {
                      backgroundColor: "#488257",
                    },
                  }}
                >
                  Submit
                </Button>
              </Box>
            )}
          </Box>
        </Box>
      </Modal>
    </>
  );
}
